import { render, staticRenderFns } from "./shopping-setting.vue?vue&type=template&id=7c03e1ab&scoped=true&"
import script from "./shopping-setting.vue?vue&type=script&lang=js&"
export * from "./shopping-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c03e1ab",
  null
  
)

export default component.exports